import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuditTableService {
  private baseUrl = `${environment.main_url}/agilelegal/audit`;

  constructor(private http: HttpClient) {}

  getAuditData(tableName: string, recordId: number, fieldName: string): Observable<any> {
    const url = `${this.baseUrl}/${tableName}/${recordId}/${fieldName}`;
    return this.http.get<any>(url);
  }
}